export default "__VITE_ASSET__vOK$8qfB__"